module.exports = __webpack_public_path__ + "img/echappee_belle_alpes.8cd2ec3e.jpg";